import {
    Input,
    Output,
    Conversion,
    BlobSource,
    BufferTarget,
    ALL_FORMATS,
    Mp4OutputFormat,
    WebMOutputFormat,
} from "mediabunny";

export const convertVideo = async (blob, format) => {
    const input = new Input({
        source: new BlobSource(blob),
        formats: ALL_FORMATS,
    });

    const target = new BufferTarget();

    const output = new Output({
        format:
            format === "mp4" ? new Mp4OutputFormat() : new WebMOutputFormat(),
        target,
    });

    const conversion = await Conversion.init({
        input,
        output,
    });

    await conversion.execute();

    return new Blob([target.buffer], {
        type: format === "mp4" ? "video/mp4" : "video/webm",
    });
};
